// externals
import type { Reducer } from 'redux';

// libraries
// interfaces/types
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { initActionTypes } from '@makemydeal/dr-shared-store';
import { SET_REFERENCE_RATE_TYPE } from '../actionTypes/baseDealActionTypes';

export type RateTypeState = {
    referenceRateType: string;
};

export const rateTypeInitialState: RateTypeState = {
    referenceRateType: ''
};

export type RateTypeReducer = Reducer<RateTypeState>;

const { INIT_SUCCESS } = initActionTypes;

export const reducer: RateTypeReducer = (state: RateTypeState = rateTypeInitialState, action: AnyFSA) => {
    switch (action.type) {
        case INIT_SUCCESS: {
            return {
                ...state,
                referenceRateType: action.payload.offer.payment?.rateType || ''
            };
        }
        case SET_REFERENCE_RATE_TYPE: {
            return { ...state, referenceRateType: action.payload.rateType };
        }
        default: {
            return state;
        }
    }
};
